export var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["USD"] = "USD";
    CurrencyCode["CAD"] = "CAD";
    CurrencyCode["EUR"] = "EUR";
    CurrencyCode["AED"] = "AED";
    CurrencyCode["AFN"] = "AFN";
    CurrencyCode["ALL"] = "ALL";
    CurrencyCode["AMD"] = "AMD";
    CurrencyCode["ARS"] = "ARS";
    CurrencyCode["AUD"] = "AUD";
    CurrencyCode["AZN"] = "AZN";
    CurrencyCode["BAM"] = "BAM";
    CurrencyCode["BDT"] = "BDT";
    CurrencyCode["BGN"] = "BGN";
    CurrencyCode["BHD"] = "BHD";
    CurrencyCode["BIF"] = "BIF";
    CurrencyCode["BND"] = "BND";
    CurrencyCode["BOB"] = "BOB";
    CurrencyCode["BRL"] = "BRL";
    CurrencyCode["BWP"] = "BWP";
    CurrencyCode["BYN"] = "BYN";
    CurrencyCode["BZD"] = "BZD";
    CurrencyCode["CDF"] = "CDF";
    CurrencyCode["CHF"] = "CHF";
    CurrencyCode["CLP"] = "CLP";
    CurrencyCode["CNY"] = "CNY";
    CurrencyCode["COP"] = "COP";
    CurrencyCode["CRC"] = "CRC";
    CurrencyCode["CVE"] = "CVE";
    CurrencyCode["CZK"] = "CZK";
    CurrencyCode["DJF"] = "DJF";
    CurrencyCode["DKK"] = "DKK";
    CurrencyCode["DOP"] = "DOP";
    CurrencyCode["DZD"] = "DZD";
    CurrencyCode["EEK"] = "EEK";
    CurrencyCode["EGP"] = "EGP";
    CurrencyCode["ERN"] = "ERN";
    CurrencyCode["ETB"] = "ETB";
    CurrencyCode["GBP"] = "GBP";
    CurrencyCode["GEL"] = "GEL";
    CurrencyCode["GHS"] = "GHS";
    CurrencyCode["GNF"] = "GNF";
    CurrencyCode["GTQ"] = "GTQ";
    CurrencyCode["HKD"] = "HKD";
    CurrencyCode["HNL"] = "HNL";
    CurrencyCode["HRK"] = "HRK";
    CurrencyCode["HUF"] = "HUF";
    CurrencyCode["IDR"] = "IDR";
    CurrencyCode["ILS"] = "ILS";
    CurrencyCode["INR"] = "INR";
    CurrencyCode["IQD"] = "IQD";
    CurrencyCode["IRR"] = "IRR";
    CurrencyCode["ISK"] = "ISK";
    CurrencyCode["JMD"] = "JMD";
    CurrencyCode["JOD"] = "JOD";
    CurrencyCode["JPY"] = "JPY";
    CurrencyCode["KES"] = "KES";
    CurrencyCode["KHR"] = "KHR";
    CurrencyCode["KMF"] = "KMF";
    CurrencyCode["KRW"] = "KRW";
    CurrencyCode["KWD"] = "KWD";
    CurrencyCode["KZT"] = "KZT";
    CurrencyCode["LBP"] = "LBP";
    CurrencyCode["LKR"] = "LKR";
    CurrencyCode["LTL"] = "LTL";
    CurrencyCode["LVL"] = "LVL";
    CurrencyCode["LYD"] = "LYD";
    CurrencyCode["MAD"] = "MAD";
    CurrencyCode["MDL"] = "MDL";
    CurrencyCode["MGA"] = "MGA";
    CurrencyCode["MKD"] = "MKD";
    CurrencyCode["MMK"] = "MMK";
    CurrencyCode["MOP"] = "MOP";
    CurrencyCode["MUR"] = "MUR";
    CurrencyCode["MXN"] = "MXN";
    CurrencyCode["MYR"] = "MYR";
    CurrencyCode["MZN"] = "MZN";
    CurrencyCode["NAD"] = "NAD";
    CurrencyCode["NGN"] = "NGN";
    CurrencyCode["NIO"] = "NIO";
    CurrencyCode["NOK"] = "NOK";
    CurrencyCode["NPR"] = "NPR";
    CurrencyCode["NZD"] = "NZD";
    CurrencyCode["OMR"] = "OMR";
    CurrencyCode["PAB"] = "PAB";
    CurrencyCode["PEN"] = "PEN";
    CurrencyCode["PHP"] = "PHP";
    CurrencyCode["PKR"] = "PKR";
    CurrencyCode["PLN"] = "PLN";
    CurrencyCode["PYG"] = "PYG";
    CurrencyCode["QAR"] = "QAR";
    CurrencyCode["RON"] = "RON";
    CurrencyCode["RSD"] = "RSD";
    CurrencyCode["RUB"] = "RUB";
    CurrencyCode["RWF"] = "RWF";
    CurrencyCode["SAR"] = "SAR";
    CurrencyCode["SDG"] = "SDG";
    CurrencyCode["SEK"] = "SEK";
    CurrencyCode["SGD"] = "SGD";
    CurrencyCode["SOS"] = "SOS";
    CurrencyCode["SYP"] = "SYP";
    CurrencyCode["THB"] = "THB";
    CurrencyCode["TND"] = "TND";
    CurrencyCode["TOP"] = "TOP";
    CurrencyCode["TRY"] = "TRY";
    CurrencyCode["TTD"] = "TTD";
    CurrencyCode["TWD"] = "TWD";
    CurrencyCode["TZS"] = "TZS";
    CurrencyCode["UAH"] = "UAH";
    CurrencyCode["UGX"] = "UGX";
    CurrencyCode["UYU"] = "UYU";
    CurrencyCode["UZS"] = "UZS";
    CurrencyCode["VEF"] = "VEF";
    CurrencyCode["VND"] = "VND";
    CurrencyCode["XAF"] = "XAF";
    CurrencyCode["XOF"] = "XOF";
    CurrencyCode["YER"] = "YER";
    CurrencyCode["ZAR"] = "ZAR";
    CurrencyCode["ZMK"] = "ZMK";
    CurrencyCode["ZWL"] = "ZWL";
})(CurrencyCode || (CurrencyCode = {}));
//# sourceMappingURL=currency.js.map